import { rem } from '@heathmont/moon-themes';
import useIsStepByStepEnabled from '~/client/components/Auth/Authenticate/AuthSteps/hooks/useIsStepByStepEnabled';
import useOnClickOutside from '~/client/hooks/events/useOnClickOutside';
import useAbTest from '~/client/hooks/useAbTest';

type Props = {
  module?: 'login' | 'signup' | 'socials';
  onClose: () => void;
};

const usePopover = ({ module, onClose }: Props) => {
  const isLogin = module === 'login';
  const { showVariant1, showVariant2 } = useAbTest({
    name: 'oneCtaRegistration',
    device: 'desktop',
  });
  const showSignIn = showVariant1 || showVariant2;
  const showLogin = showSignIn ? false : isLogin;
  const isRegister = module === 'signup';
  const { elementRef } = useOnClickOutside<HTMLDivElement>({
    handler: () => onClose(),
  });

  const isStepByStepRegistrationEnabled = useIsStepByStepEnabled();

  const containerWidth = isStepByStepRegistrationEnabled ? rem(385) : rem(328);

  return {
    showLogin,
    isRegister,
    elementRef,
    containerWidth,
  };
};

export default usePopover;
